import React, { useEffect, useState } from 'react';
import { __experimentalInputControl as InputControl } from '@wordpress/components';

function FontName(props) {

    const id = props.idx;
    const [name, setName] = useState();
    const handleChange = ( name ) => props.handleFontNameChange({idx:id,name:name});
    
    return (
        <>
            <InputControl
                label="Font Name"
                name="name"
                data-index={props.idx}
                type="text"
                value={ name ?? props.name }
                onChange={ ( newName ) => {
                   setName( newName ?? props.name ); 
                   handleChange( newName )
                }}
            />
        </>
    );

}
export default FontName